import { render } from "./AGBDialog.vue?vue&type=template&id=4fa37e10"
import script from "./AGBDialog.vue?vue&type=script&lang=js"
export * from "./AGBDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__